import { Button, Drawer, Row, Space, Form } from 'antd';
import NumberInput from 'app/components/NumberInput/NumberInput';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { checkIsPositiveNumber } from 'utils/validationHelpers';

interface IProps {
  isOpen: boolean;
  isSubmitLoading: boolean;
  onClose: () => void;
  onSubmit: (payload: {
    price: number;
    sellingPrice: number;
    efficiency: number;
  }) => void;
}

const TaskCategoryPriceDrawer: FC<IProps> = ({
  isOpen,
  onClose,
  onSubmit,
  isSubmitLoading,
}) => {
  const { t } = useTranslation();

  const [form] = Form.useForm();

  // Clear form on close
  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
    }
  }, [isOpen, form]);

  const onFinish = (values: {
    price: number;
    sellingPrice?: string;
    efficiency?: string;
  }) => {
    const price = Number(values.price);
    const sellingPrice = Number(values.sellingPrice);
    const efficiency = Number(values.efficiency);

    onSubmit({ price, sellingPrice, efficiency });
  };

  return (
    <Drawer
      title={t('UsedResource.PriceDrawer.Title', 'Change price')}
      visible={isOpen}
      forceRender={true}
      onClose={onClose}
      destroyOnClose
      placement="right"
      width={400}
      footer={
        <Row justify="end">
          <Space>
            <Button onClick={onClose}>
              {t('UsedResource.PriceDrawer.Cancel', 'Cancel')}
            </Button>

            <Button
              loading={isSubmitLoading}
              form="companyShareForm"
              key="submit"
              htmlType="submit"
              type="primary"
            >
              {t('UsedResource.PriceDrawer.Save', 'Save')}
            </Button>
          </Space>
        </Row>
      }
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={{ layout: 'vertical' }}
        requiredMark="optional"
        id="companyShareForm"
        onFinish={onFinish}
      >
        <Form.Item
          label={t('TaskCategoriesCard.Table.PrimeCost', 'Prime cost (Eur)')}
          name="price"
          rules={[{ required: true }, { validator: checkIsPositiveNumber }]}
        >
          <NumberInput
            placeholder={t(
              'TaskCategoriesCard.Table.PrimeCost',
              'Prime cost (Eur)',
            )}
          />
        </Form.Item>

        <Form.Item
          label={t(
            'TaskCategoriesCard.Table.SellingPrice',
            'Selling Price (Eur)',
          )}
          name="sellingPrice"
          rules={[{ required: true }, { validator: checkIsPositiveNumber }]}
        >
          <NumberInput
            placeholder={t(
              'TaskCategoriesCard.Table.SellingPrice',
              'Selling Price (Eur)',
            )}
          />
        </Form.Item>

        <Form.Item
          label={t('TaskCategoriesCard.Table.Efficiency', 'Efficiency (Ha/h)')}
          name="efficiency"
          rules={[{ required: true }, { validator: checkIsPositiveNumber }]}
        >
          <NumberInput
            placeholder={t(
              'TaskCategoriesCard.Table.Efficiency',
              'Efficiency (Ha/h)',
            )}
          />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default TaskCategoryPriceDrawer;
